import { BfUserStore } from '@tw/tw-runtime';

export class UserStore extends BfUserStore {
  protected setUserToken(token: string | undefined) {
    super.setUserToken(token);
  }
}
